module.exports = __webpack_public_path__ + "img/motorcycle-green-left.e0062924.jpg";